/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface ClassLocationBase
 */
export interface ClassLocationBaseOptional {
  /**
   *
   * @type {string}
   * @memberof ClassLocationBase
   */
  locationName?: string;
  /**
   *
   * @type {boolean}
   * @memberof ClassLocationBase
   */
  active?: boolean;
}

export interface ClassLocationBase extends ClassLocationBaseOptional {
  /**
   *
   * @type {string}
   * @memberof ClassLocationBase
   */
  locationName?: string;
  /**
   *
   * @type {boolean}
   * @memberof ClassLocationBase
   */
  active?: boolean;
}

export interface ClassLocationBaseTrackedI {
  /**
   *
   * @type {string}
   * @memberof ClassLocationBase
   */
  locationName?: string;
  locationNameIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassLocationBase
   */
  active?: boolean;
  activeIsSet: boolean;
}

transformDatesMap.set(
  "ClassLocationBase",
  function (model: ClassLocationBase) {},
);

export type ClassLocationBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  locationName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  active: PropertyMeta<MetaTypeBase<boolean>>;
}>;

export var ClassLocationBaseMeta: ClassLocationBaseMetaI =
  {} as ClassLocationBaseMetaI;
ClassLocationBaseMeta = typeMeta("ClassLocationBase", {
  locationName: propertyMeta(
    "locationName",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  active: propertyMeta("active", false, false, false, MetaTypesBase.boolean),
});

const metaI = ClassLocationBaseMeta;

registerMeta(() => {});

export class ClassLocationBaseTracked implements ClassLocationBaseTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  locationName__I?: string = undefined;
  locationNameIsSet: boolean = false;
  set locationName(v: undefined | string) {
    if (v !== undefined) {
      this.locationName__I = v;
      this.locationNameIsSet = true;
    } else {
      this.locationName__I = v || undefined;
      this.locationNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get locationName() {
    return this.locationName__I;
  }
  active__I?: boolean = undefined;
  activeIsSet: boolean = false;
  set active(v: undefined | boolean) {
    if (v !== undefined) {
      this.active__I = v;
      this.activeIsSet = true;
    } else {
      this.active__I = v || undefined;
      this.activeIsSet = false;
    }
    this.changeTracker = true;
  }
  get active() {
    return this.active__I;
  }
  constructor(config?: ClassLocationBaseOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: ClassLocationBaseOptional,
    options?: AssignOptions,
  ): ClassLocationBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.locationName &&
      this.locationNameApplyFilter(optionsRequired.filter)
    ) {
      this.locationName = config.locationName;
      if (optionsRequired.unassign) this.locationNameIsSet = false;
      else this.locationNameIsSet = true;
    }
    if (config.active && this.activeApplyFilter(optionsRequired.filter)) {
      this.active = config.active;
      if (optionsRequired.unassign) this.activeIsSet = false;
      else this.activeIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): ClassLocationBaseTrackedI {
    const cloned = {} as ClassLocationBaseTrackedI;
    if (
      this.locationNameIsSetDeep() &&
      this.locationNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.locationNameIsSet = true;
      cloned.locationName = this.locationName;
    } else {
      //cloned.locationNameIsSet = false
    }
    if (
      this.activeIsSetDeep() &&
      this.activeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.activeIsSet = true;
      cloned.active = this.active;
    } else {
      //cloned.activeIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): ClassLocationBaseTrackedI {
    if (!this.locationNameApplyFilter(filter)) this.locationNameIsSet = false;

    if (!this.activeApplyFilter(filter)) this.activeIsSet = false;

    return this;
  }
  locationNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassLocationBaseMeta.locationName,
      ClassLocationBaseMeta,
      this.locationName,
      this,
    );
  }
  locationNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.locationNameIsSet && this.locationNameApplyFilter(filter))
      return true;

    return false;
  }
  activeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassLocationBaseMeta.active,
      ClassLocationBaseMeta,
      this.active,
      this,
    );
  }
  activeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.activeIsSet && this.activeApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.locationNameIsSetDeep(filter)) return true;
    if (this.activeIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
